export default {"src":"/_next/static/media/video-play.998a9302.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};